<template>
  <div class="grid">
		<div class="col-12">
            <div class="card">
                <Toast/>
                <Error :errors="errors"/>

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter"/>
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number" @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('csv')" />
                                <!-- <Button :loading="loadingPdf" label="Export PDF" icon="pi pi-file-pdf" class="p-button p-button-danger mr-2 my-1 inline-block" @click="exportAllPDF()" /> -->
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{width:'20px'}" >
                        <template #body="slotProps">
                        {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="username" header="Username">
                        <template #body="slotProps">
                            {{slotProps.data.username}}
                        </template>
                    </Column>
                    <Column field="name_" header="Nama">
                        <template #body="slotProps">
                            {{slotProps.data.name_}}
                        </template>
                    </Column>
                    <Column field="activity_type" header="Activity">
                        <template #body="slotProps">
                            {{slotProps.data.activity_type}}
                        </template>
                    </Column>
                    <Column field="total_activity" header="Total Activity">
                        <template #body="slotProps">
                            {{slotProps.data.total_activity}}
                        </template>
                    </Column>
                    <Column field="activity_date" header="Activity Date">
                        <template #body="slotProps">
                            {{slotProps.data.activity_date}}
                        </template>
                    </Column>
                    <Column field="activity_time" header="Activity Time">
                        <template #body="slotProps">
                            {{slotProps.data.activity_time}}
                        </template>
                    </Column>
					<!-- <Column header="Aksi" headerStyle="min-width:10rem;">
						<template #body="slotProps">
                            <Button icon="pi pi-download" class="p-button-rounded p-button-danger" @click="exportPDF(slotProps.data.ad_id)"/>
						</template>
					</Column> -->
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]">
                    <template>
                        {{totalItemsCount}}
                    </template>
                </Paginator>

            </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';
import Filter from '../../components/report/user-active/Filter.vue';
import Error from '../../components/Error.vue';

export default {
    components: {
		'Filter': Filter,
		'Error': Error,
	},
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,
            loadingPdf: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        }
    },
    computed:{
        ...mapGetters(['errors']),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        // DATATABLE
        getDataTable(){
          
            this.loading=true;
            this.$refs.filter.loading = true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/user-active',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                    "userid" : this.$refs.filter.filters.userid,
                    "activity" : this.$refs.filter.filters.activity,
                    "tanggal_mulai" : this.$refs.filter.period_start_label,
                    "tanggal_akhir" : this.$refs.filter.period_end_label,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
              this.$refs.filter.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading=false;
                this.$refs.filter.loading = false;
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext){

            if(ext == 'xlsx'){
                this.loadingExcel=true;
            }else if(ext == 'csv'){
                this.loadingCsv=true;
            }

            this.axios({
            method: 'GET',
            url: process.env.VUE_APP_ROOT_API + 'web/user-active/export',
            responseType: 'blob',
            params: {
                "ext" : ext,
                "userid" : this.$refs.filter.filters.userid,
                "activity" : this.$refs.filter.filters.activity,
                "tanggal_mulai" : this.$refs.filter.period_start_label,
                "tanggal_akhir" : this.$refs.filter.period_end_label,
            }
            })
            .then(response => {
                let fileUrl = window.URL.createObjectURL(response.data);
                let fileLink = document.createElement('a');

                fileLink.href = fileUrl;

                fileLink.setAttribute('download', 'Report User Active Export.' + ext);
                
                document.body.appendChild(fileLink)

                fileLink.click();
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }

            })
            .catch((err) => {
                console.log(err);
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }
            });
        },
        // exportPDF(ad_id){

        //     this.axios({
        //         method: 'GET',
        //         url: 'https://pdf-motul.tuas.my.id/api/pdf/account-dev',
        //         responseType: 'blob',
        //         params: {
        //             "ad_id" : ad_id
        //         }
        //     })
        //     .then(response => {
        //         let fileUrl = window.URL.createObjectURL(response.data);
        //         let fileLink = document.createElement('a');

        //         fileLink.href = fileUrl;

        //         fileLink.target = '_blank';
                
        //         document.body.appendChild(fileLink)

        //         fileLink.click();

        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });
        // },
        // exportAllPDF(){

        //     this.loadingPdf=true;

        //     this.axios({
        //         method: 'GET',
        //         url: 'https://pdf-motul.tuas.my.id/api/pdf/account-dev',
        //         responseType: 'blob',
        //         params: {
        //             "user_id": this.$refs.filter.filters.userid ? [this.$refs.filter.filters.userid] : [],
        //             "ad_type": this.$refs.filter.filters.tipe ? [this.$refs.filter.filters.tipe] : [],
        //             "start_date" : this.$refs.filter.period_start_label,
        //             "end_date" : this.$refs.filter.period_end_label,
        //         }
        //     })
        //     .then(response => {
        //         let fileUrl = window.URL.createObjectURL(response.data);
        //         let fileLink = document.createElement('a');

        //         fileLink.href = fileUrl;

        //         fileLink.target = '_blank';
                
        //         document.body.appendChild(fileLink)

        //         fileLink.click();
                    
        //         this.loadingPdf = false;
        //     })
        //     .catch((err) => {
        //         console.log(err);

        //         this.loadingPdf=false;
        //     });
        // },
    }
}
</script>
